import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

/*
    USAGE :
    <button class="myElement" data-module="SetFocus" data-focus=".js-element"></button>
    data-focus : [scoped element ".myClass"] 
 */

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
        this.scrollers = document.querySelectorAll('.scroller');
        this.scrollers.forEach((scroller) => {
            // add data-animated="true" to every `.scroller` on the page
            scroller.setAttribute("data-animated", true);

            // Make an array from the elements within `.scroller-inner`
            const scrollerInner = scroller.querySelector(".scroller__inner");
            let scrollerContent = Array.from(scrollerInner.children);

            // If item count is less than 8, duplicate items to have at least 8 items
            while (scrollerContent.length < 16) {
                scrollerContent = scrollerContent.concat(
                    scrollerContent.map(item => {
                        const duplicatedItem = item.cloneNode(true);
                        duplicatedItem.setAttribute("aria-hidden", true);
                        scrollerInner.appendChild(duplicatedItem);
                        return duplicatedItem;
                    })
                );
            }
        });
    }

    destroy() {
        this.scrollers.forEach((scroller) => {
            scroller.removeAttribute("data-animated");
            const scrollerInner = scroller.querySelector(".scroller__inner");
            const scrollerContent = Array.from(scrollerInner.children);
            scrollerContent.forEach((item) => {
                item.remove();
            });
        });
    }

}